import React, { useState } from "react";
import  "./LineLevelBoard.css"
import LineLevelBoardTable from "./LineLevelBoardTable"
import LineLevelBoardTableTwo from "./LineLevelBoardTableTwo"
import { Table, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment-timezone';
import ButtonComp from "../ButtonComp/ButtonComp";

const LineLevelBoard = () => {

  const { current } = useSelector((state) => state?.plant);
  const { plant } = useSelector(state => state?.plant?.current)
  const { stats } = useSelector((state) => state.kpis);
  const formattedOEE = stats?.oee;
  const activeStatus = stats?.status;
  const updated_at = stats?.updated_at;
  const shiftWiseTarget = stats?.shiftWiseTarget

  const getGoodoutputHourlyData = (formattedOEE,status,updated_at, isTable = false) => {
    const {line,machine,plant} = current;
    const {manualShift,plannedProductionTime,shiftWiseTarget} = stats
    let canBeUpdated = true;
    let dailyTarget = shiftWiseTarget;
    let lastRowValues = null
    let lastGoodOutput = 0
    let lastTarget = 0;
    let generalTarget = shiftWiseTarget;
    let totalHours =((plannedProductionTime/60));
    generalTarget = (generalTarget/plannedProductionTime);
    let targetOee = (machine && machine.targetOee)?machine.targetOee : (line && line.targetOee) ?line.targetOee:1;
    let resultArray = [];
    let oldGC = 0;
    let timeNow = moment(new Date()).toDate();
    if (!formattedOEE) return [];
    let lengthOfData = formattedOEE.length;
    let i = 0;
    for (i ; i <= lengthOfData - 1; i = i + 60) {
      let temp = {};
      if (!isTable) {
        
        temp = formattedOEE[i-1] ? { goodOutput: formattedOEE[i-1].gc, time: formattedOEE[i-1].time } : { goodOutput: formattedOEE[i].gc, time: formattedOEE[i].time };
      } else if (i != 0) {
        if (moment(formattedOEE[i].time).isBefore(timeNow) && (status!='shift ended' || (status =='shift ended' && moment(formattedOEE[i].time).isBefore(updated_at)))){
        temp = {
          Time:
            moment(formattedOEE[i - 60].time)
              .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
              .format('h:mm:a') +
            ' - ' +
            moment(formattedOEE[i].time)
              .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
              .format('h:mm:a'),
          Actual_Output: (formattedOEE[i-1].gc - oldGC > 0 ?formattedOEE[i-1].gc - oldGC : 0),
          Target_Output: ((targetOee*(formattedOEE[i].lineSpeed ? formattedOEE[i].lineSpeed : 1)*60)/100).toFixed(0),
          Oee:formattedOEE[i-1].oee,
          startTime:formattedOEE[i - 60].time,
          endTime:formattedOEE[i].time
        };
        let hourlyTarget = dailyTarget/totalHours;

        dailyTarget = dailyTarget-hourlyTarget;
        
        temp.difference = temp.Actual_Output - temp.Target_Output;
        dailyTarget = dailyTarget-(temp.Actual_Output - hourlyTarget);
        temp.shortFall = temp.Actual_Output - hourlyTarget;
        let totalMinutes = (moment.duration(moment(formattedOEE[i].time).diff(moment(formattedOEE[i-60].time).toDate())).asMinutes()).toFixed(0);
        temp.target = (generalTarget*totalMinutes);
        temp.pp = totalHours;
        temp.revisedHourlyTarget = hourlyTarget;
        totalHours = totalHours-1;

        oldGC = formattedOEE[i-1].gc;
      }
      else{
        if(formattedOEE[i] && formattedOEE[i].time && (status!='shift ended' || (status =='shift ended' && moment(formattedOEE[i].time).isBefore(updated_at)))){
          let instDiff = (moment.duration(moment(formattedOEE[i].time).diff(moment(timeNow).toDate())).asMinutes()).toFixed(0);
          let newDiff = i - parseInt(instDiff);
          if(formattedOEE[(newDiff)] && parseInt(instDiff) <60)
          {
            temp = {
              Time:
                moment(formattedOEE[i - 60].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a') +
                ' - ' +
                moment(formattedOEE[i].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a'),
              Actual_Output: (formattedOEE[newDiff-5].gc - oldGC > 0 ?formattedOEE[newDiff-5].gc - oldGC : 0),
              Target_Output: ((targetOee*(formattedOEE[newDiff-5].lineSpeed ? formattedOEE[newDiff-5].lineSpeed : 1)*60)/100).toFixed(0),
              Oee:formattedOEE[newDiff-5].oee,
              startTime:formattedOEE[i - 60].time,
              endTime:formattedOEE[i].time
            };
            let hourlyTarget = dailyTarget/totalHours;

            dailyTarget = dailyTarget-hourlyTarget;
            
            temp.difference = temp.Actual_Output - temp.Target_Output;
            dailyTarget = dailyTarget-(temp.Actual_Output - hourlyTarget);
            temp.shortFall = temp.Actual_Output - hourlyTarget;
            let totalMinutes = (moment.duration(moment(formattedOEE[i].time).diff(moment(formattedOEE[i-60].time).toDate())).asMinutes()).toFixed(0);

            temp.target = (generalTarget*totalMinutes);
            temp.pp = totalHours;
            temp.revisedHourlyTarget = hourlyTarget;
            totalHours = totalHours-1;
            oldGC = formattedOEE[i-1].gc;
          }
          else{
            temp = {
              Time:
                moment(formattedOEE[i - 60].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a') +
                ' - ' +
                moment(formattedOEE[i].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a'),
              Actual_Output: 'N/A',//(formattedOEE[i].gc - oldGC > 0 ?formattedOEE[i].gc - oldGC : 0),
              Target_Output: ((targetOee*(formattedOEE[i].lineSpeed ? formattedOEE[i].lineSpeed : 1)*60)/100).toFixed(0),
              Oee:'N/A',
              startTime:formattedOEE[i - 60].time,
              endTime:formattedOEE[i].time
            };
            let hourlyTarget = dailyTarget/totalHours;

            dailyTarget = dailyTarget-hourlyTarget;
            
            temp.difference = temp.Actual_Output - temp.Target_Output;
            dailyTarget = dailyTarget-(temp.Actual_Output - hourlyTarget);
            temp.shortFall = temp.Actual_Output - hourlyTarget;
            let totalMinutes = (moment.duration(moment(formattedOEE[i].time).diff(moment(formattedOEE[i-60].time).toDate())).asMinutes()).toFixed(0);
            temp.target = (generalTarget*totalMinutes);
            temp.pp = totalHours;
            temp.revisedHourlyTarget = hourlyTarget;
            totalHours = totalHours-1;

            oldGC = formattedOEE[i-1].gc;
          }
        }
      }
      if(moment(temp.startTime).isBefore(timeNow) && moment(temp.endTime).isAfter(timeNow))
        {
          temp.isCurrent = true;
          canBeUpdated = false;
        }
      if(canBeUpdated)
      {
        lastGoodOutput += temp.Actual_Output;
        lastTarget += temp.target
        lastRowValues = {...temp};
      }  
      if (temp.time || temp.Time) resultArray.push(temp);
    }
    }
    if(i != ((lengthOfData - 1)+60))
    {
      //if (moment(formattedOEE[lengthOfData - 1].time).isBefore(timeNow)){
      let temp ={}
        if (!isTable) {
          temp = { goodOutput: formattedOEE[lengthOfData - 2].gc, time: formattedOEE[lengthOfData - 2].time };
        } else if (i != 0) {
          if(moment(formattedOEE[lengthOfData - 1].time).isBefore(timeNow) && (status!='shift ended' || (status =='shift ended' && moment(formattedOEE[lengthOfData - 1].time).isBefore(updated_at)))){
          temp = {
            Time:
              moment(formattedOEE[i - 60].time)
                .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                .format('h:mm:a') +
              ' - ' +
              moment(formattedOEE[lengthOfData - 1].time)
                .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                .format('h:mm:a'),
            Actual_Output: (formattedOEE[lengthOfData - 2].gc - oldGC > 0 ?formattedOEE[lengthOfData - 2].gc - oldGC : 0),
            Target_Output: ((targetOee*(formattedOEE[lengthOfData - 2].lineSpeed ? formattedOEE[lengthOfData - 2].lineSpeed : 1)*(60-(i-lengthOfData)))/100).toFixed(0),
            Oee:formattedOEE[lengthOfData - 2].oee,
            startTime:formattedOEE[i - 60].time,
            endTime:formattedOEE[lengthOfData - 1].time

          };
          let hourlyTarget = dailyTarget/totalHours;

          dailyTarget = dailyTarget-hourlyTarget;
          
          temp.difference = temp.Actual_Output - temp.Target_Output;
          dailyTarget = dailyTarget-(temp.Actual_Output - hourlyTarget);
          temp.shortFall = temp.Actual_Output - hourlyTarget;
          let totalMinutes = (moment.duration(moment(formattedOEE[lengthOfData - 1].time).diff(moment(formattedOEE[i-60].time).toDate())).asMinutes()).toFixed(0);

          temp.target = (generalTarget*totalMinutes);
          temp.pp = totalHours;
          temp.revisedHourlyTarget = hourlyTarget;
          totalHours = totalHours-1;
          oldGC = formattedOEE[lengthOfData - 2].gc;
        }
        else if(status!='shift ended')
        {
          let instDifff = (moment.duration(moment(formattedOEE[lengthOfData-1].time).diff(moment(timeNow).toDate())).asMinutes()).toFixed(0);
          let newDifff = (lengthOfData-1) - parseInt(instDifff);
          if(formattedOEE[(newDifff)] && parseInt(instDifff) <60)
          {
            temp = {
              Time:
                moment(formattedOEE[i-60].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a') +
                ' - ' +
                moment(formattedOEE[lengthOfData-1].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a'),
              Actual_Output: (formattedOEE[newDifff-5].gc - oldGC > 0 ?formattedOEE[newDifff-5].gc - oldGC : 0),
              Target_Output: ((targetOee*(formattedOEE[newDifff-5].lineSpeed ? formattedOEE[newDifff-5].lineSpeed : 1)*(60-(i-lengthOfData)))/100).toFixed(0),
              Oee:formattedOEE[newDifff-5].oee,
              startTime:formattedOEE[i - 60].time,
              endTime:formattedOEE[lengthOfData - 1].time
              //((targetOee*(formattedOEE[lengthOfData - 2].lineSpeed ? formattedOEE[lengthOfData - 2].lineSpeed : 1)*(60-(i-lengthOfData)))/100).toFixed(0)
            };
            let hourlyTarget = dailyTarget/totalHours;

            dailyTarget = dailyTarget-hourlyTarget;
            
            temp.difference = temp.Actual_Output - temp.Target_Output;
            dailyTarget = dailyTarget-(temp.Actual_Output - hourlyTarget);
            temp.shortFall = temp.Actual_Output - hourlyTarget;
            let totalMinutes = (moment.duration(moment(formattedOEE[lengthOfData - 1].time).diff(moment(formattedOEE[i-60].time).toDate())).asMinutes()).toFixed(0);
            temp.target = (generalTarget*totalMinutes);
            temp.pp = totalHours;
            temp.revisedHourlyTarget = hourlyTarget;
            totalHours = totalHours-1;
            oldGC = formattedOEE[i-60].gc;
          }
          else if(formattedOEE[(newDifff)] && parseInt(instDifff) >60){
            temp = {
              Time:
                moment(formattedOEE[i-60].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a') +
                ' - ' +
                moment(formattedOEE[lengthOfData-1].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a'),
              Actual_Output: 'N/A',//(formattedOEE[newDifff-5].gc - oldGC > 0 ?formattedOEE[newDifff-5].gc - oldGC : 0),
              Target_Output: ((targetOee*(formattedOEE[newDifff-5].lineSpeed ? formattedOEE[newDifff-5].lineSpeed : 1)*(60-(i-lengthOfData)))/100).toFixed(0),
              Oee:'N/A',

            };
            let hourlyTarget = dailyTarget/totalHours;

            dailyTarget = dailyTarget-hourlyTarget;
            
            temp.difference = temp.Actual_Output - temp.Target_Output;
            dailyTarget = dailyTarget-(temp.Actual_Output - hourlyTarget);
            temp.shortFall = temp.Actual_Output - hourlyTarget;
            let totalMinutes = (moment.duration(moment(formattedOEE[lengthOfData - 1].time).diff(moment(formattedOEE[i-60].time).toDate())).asMinutes()).toFixed(0);
            temp.target = (generalTarget*totalMinutes);
            temp.pp = totalHours;
            temp.revisedHourlyTarget = hourlyTarget;
            totalHours = totalHours-1;
            oldGC = formattedOEE[i-60].gc;
          }
        }
      }
      if(temp.startTime && (moment(temp.startTime).isBefore(timeNow) && moment(temp.endTime).isAfter(timeNow)))
      {
        temp.isCurrent = true;
        canBeUpdated = false;
      }
    if(canBeUpdated)
    {
      lastGoodOutput += temp.Actual_Output;
      lastTarget += temp.target
      lastRowValues = {...temp};

    }  
      if (temp.time || temp.Time) resultArray.push(temp);
      //}
    }
    if(status == 'shift ended'){
      const {goodOutput,oeeFinal} = stats
      let instDiff = (moment.duration(moment(updated_at).diff(formattedOEE[0].time)).asMinutes()).toFixed(0);
      let last = instDiff % 60;
      let lastUsedData = resultArray.length * 60;
      let lastValueToBeUsed = lastUsedData+last-2
      if(formattedOEE[lastUsedData] && formattedOEE[lastUsedData].time){
      let temp = {
        Time:
          moment(formattedOEE[lastUsedData].time)
            .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
            .format('h:mm:a') +
          ' - ' +
          moment(formattedOEE[lastValueToBeUsed].time)
            .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
            .format('h:mm:a'),
        Actual_Output: (goodOutput - oldGC > 0 ?goodOutput - oldGC : 0),
        Target_Output: ((targetOee*(formattedOEE[lastValueToBeUsed].lineSpeed ? formattedOEE[lastValueToBeUsed].lineSpeed : 1)*(last-2))/100).toFixed(0),
        Oee:oeeFinal,
        startTime:formattedOEE[lastUsedData].time,
        endTime:formattedOEE[lastValueToBeUsed].time
      };
      let hourlyTarget = dailyTarget/totalHours;

      dailyTarget = dailyTarget-hourlyTarget;
      
      temp.difference = temp.Actual_Output - temp.Target_Output;
      dailyTarget = dailyTarget-(temp.Actual_Output - hourlyTarget);
      temp.shortFall = temp.Actual_Output - hourlyTarget;
      let totalMinutes = (moment.duration(moment(formattedOEE[lastValueToBeUsed].time).diff(moment(formattedOEE[lastUsedData].time).toDate())).asMinutes()).toFixed(0);

      temp.target = (generalTarget*totalMinutes);
      temp.pp = totalHours;
      temp.revisedHourlyTarget = hourlyTarget;
      totalHours = totalHours-1;
      oldGC = goodOutput;
      if(moment(temp.startTime).isBefore(timeNow) && moment(temp.endTime).isAfter(timeNow))
      {
        temp.isCurrent = true;
        canBeUpdated = false;
      }
    if(canBeUpdated)
    {
      lastGoodOutput += temp.Actual_Output;
      lastTarget += temp.target
      lastRowValues = {...temp};

    }  

      if (temp.time || temp.Time) resultArray.push(temp);}
    }
    if(manualShift)
    {
      let updatedArray =[];
      resultArray = resultArray.map(singleRow => {
        singleRow.Actual_Output = 'N/A'
        singleRow.difference = 'N/A'
        singleRow.Oee = 'N/A'
        singleRow.shortFall = 'N/A'
        singleRow.revisedHourlyTarget = 'N/A'
        return singleRow;
      })
    }
    return resultArray;
  };

  const getGoodoutputHourlyDataForFiveMinutes = (formattedOEE,status,updated_at, isTable = false) => {
    const {line,machine,plant} = current;
    let targetOee = (machine && machine.targetOee)?machine.targetOee : (line && line?.targetOee) ? line?.targetOee:1;
    let resultArray = [];
    let oldGC = 0;
    let timeNow = moment(new Date()).toDate();

    if (!formattedOEE) return [];
    let lengthOfData = formattedOEE.length;
    let i = 0;
    for (i ; i <= lengthOfData - 1; i = i + 12) {
      let temp = {};
      if (!isTable) {
        
        temp = formattedOEE[i-1] ? { goodOutput: formattedOEE[i-1].gc, time: formattedOEE[i-1].time } : { goodOutput: formattedOEE[i].gc, time: formattedOEE[i].time };
      } else if (i != 0) {
        if (moment(formattedOEE[i].time).isBefore(timeNow) && (status!='shift ended' || (status =='shift ended' && moment(formattedOEE[i].time).isBefore(updated_at)))){
        temp = {
          Time:
            moment(formattedOEE[i - 12].time)
              .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
              .format('h:mm:a') +
            ' - ' +
            moment(formattedOEE[i].time)
              .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
              .format('h:mm:a'),
          Actual_Output: (formattedOEE[i-1].gc - oldGC > 0 ?formattedOEE[i-1].gc - oldGC : 0),
          Target_Output: ((targetOee*(formattedOEE[i].lineSpeed ? formattedOEE[i].lineSpeed : 1)*60)/100).toFixed(0)

        };
        temp.difference = temp.Actual_Output - temp.Target_Output;
        oldGC = formattedOEE[i-1].gc;
      }
      else{
        if(formattedOEE[i] && formattedOEE[i].time && (status!='shift ended' || (status =='shift ended' && moment(formattedOEE[i].time).isBefore(updated_at)))){
          let instDiff = ((moment.duration(moment(formattedOEE[i].time).diff(moment(timeNow).toDate())).asMinutes())/5).toFixed(0);
          let newDiff = i - parseInt(instDiff);
          if(formattedOEE[(newDiff)] && parseInt(instDiff) <12)
          {
            temp = {
              Time:
                moment(formattedOEE[i - 12].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a') +
                ' - ' +
                moment(formattedOEE[i].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a'),
              Actual_Output: (formattedOEE[newDiff-1].gc - oldGC > 0 ?formattedOEE[newDiff-1].gc - oldGC : 0),
              Target_Output: ((targetOee*(formattedOEE[newDiff-1].lineSpeed ? formattedOEE[newDiff-1].lineSpeed : 1)*60)/100).toFixed(0)
  
            };
            temp.difference = temp.Actual_Output - temp.Target_Output;
            oldGC = formattedOEE[i-1].gc;
          }
          else{
            temp = {
              Time:
                moment(formattedOEE[i - 12].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a') +
                ' - ' +
                moment(formattedOEE[i].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a'),
              Actual_Output: (formattedOEE[i].gc - oldGC > 0 ?formattedOEE[i].gc - oldGC : 0),
              Target_Output: ((targetOee*(formattedOEE[i].lineSpeed ? formattedOEE[i].lineSpeed : 1)*60)/100).toFixed(0)
  
            };
            temp.difference = temp.Actual_Output - temp.Target_Output;
            oldGC = formattedOEE[i-1].gc;
          }
        }
      }
      if (temp.time || temp.Time) resultArray.push(temp);
    }
    }
    if(i != ((lengthOfData - 1)+12))
    {
      //if (moment(formattedOEE[lengthOfData - 1].time).isBefore(timeNow)){
      let temp ={}
        if (!isTable) {
          temp = { goodOutput: formattedOEE[lengthOfData - 2].gc, time: formattedOEE[lengthOfData - 2].time };
        } else if (i != 0) {
          if(moment(formattedOEE[lengthOfData - 1].time).isBefore(timeNow) && (status!='shift ended' || (status =='shift ended' && moment(formattedOEE[lengthOfData - 1].time).isBefore(updated_at)))){
          temp = {
            Time:
              moment(formattedOEE[i - 12].time)
                .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                .format('h:mm:a') +
              ' - ' +
              moment(formattedOEE[lengthOfData - 1].time)
                .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                .format('h:mm:a'),
            Actual_Output: (formattedOEE[lengthOfData - 2].gc - oldGC > 0 ?formattedOEE[lengthOfData - 2].gc - oldGC : 0),
            Target_Output: ((targetOee*(formattedOEE[lengthOfData - 2].lineSpeed ? formattedOEE[lengthOfData - 2].lineSpeed : 1)*(60-((i-lengthOfData)*5)))/100).toFixed(0)

          };
          temp.difference = temp.Actual_Output - temp.Target_Output;
          oldGC = formattedOEE[lengthOfData - 2].gc;
        }
        else if(status!='shift ended')
        {
          let instDifff = ((moment.duration(moment(formattedOEE[lengthOfData-1].time).diff(moment(timeNow).toDate())).asMinutes())/5).toFixed(0);
          let newDifff = (lengthOfData-1) - parseInt(instDifff);
          if(formattedOEE[(newDifff)] && parseInt(instDifff) <12)
          {
            temp = {
              Time:
                moment(formattedOEE[i-12].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a') +
                ' - ' +
                moment(formattedOEE[lengthOfData-1].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a'),
              Actual_Output: (formattedOEE[newDifff-1].gc - oldGC > 0 ?formattedOEE[newDifff-1].gc - oldGC : 0),
              Target_Output: ((targetOee*(formattedOEE[newDifff-1].lineSpeed ? formattedOEE[newDifff-1].lineSpeed : 1)*(60-((i-lengthOfData)*5)))/100).toFixed(0)
              //((targetOee*(formattedOEE[lengthOfData - 2].lineSpeed ? formattedOEE[lengthOfData - 2].lineSpeed : 1)*(60-(i-lengthOfData)))/100).toFixed(0)
            };
            temp.difference = temp.Actual_Output - temp.Target_Output;
            oldGC = formattedOEE[i-60].gc;
          }
          else if(formattedOEE[(newDifff)] && parseInt(instDifff) >12){
            temp = {
              Time:
                moment(formattedOEE[i-12].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a') +
                ' - ' +
                moment(formattedOEE[lengthOfData-1].time)
                  .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
                  .format('h:mm:a'),
              Actual_Output: 0,//(formattedOEE[newDifff-5].gc - oldGC > 0 ?formattedOEE[newDifff-5].gc - oldGC : 0),
              Target_Output: ((targetOee*(formattedOEE[newDifff-1].lineSpeed ? formattedOEE[newDifff-1].lineSpeed : 1)*(60-((i-lengthOfData)*5)))/100).toFixed(0)
  
            };
            temp.difference = temp.Actual_Output - temp.Target_Output;
            oldGC = formattedOEE[i-12].gc;
          }
        }
      }
        if (temp.time || temp.Time) resultArray.push(temp);
      //}
    }
    if(status == 'shift ended'){
      const {goodOutput} = stats
      let instDiff = (moment.duration(moment(updated_at).diff(formattedOEE[0].time)).asMinutes()).toFixed(0);
      let last = instDiff % 12;
      let lastUsedData = resultArray.length * 12;
      let lastValueToBeUsed = lastUsedData+last-1
      if(formattedOEE[lastUsedData] && formattedOEE[lastUsedData].time){
      let temp = {
        Time:
          moment(formattedOEE[lastUsedData].time)
            .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
            .format('h:mm:a') +
          ' - ' +
          moment(formattedOEE[lastValueToBeUsed].time)
            .tz(plant.timezone ? plant.timezone : 'Asia/Karachi')
            .format('h:mm:a'),
        Actual_Output: (goodOutput - oldGC > 0 ?goodOutput - oldGC : 0),
        Target_Output: ((targetOee*(formattedOEE[lastValueToBeUsed].lineSpeed ? formattedOEE[lastValueToBeUsed].lineSpeed : 1)*(last-1))/100).toFixed(0)

      };
      temp.difference = temp.Actual_Output - temp.Target_Output;
      oldGC = goodOutput;
      if (temp.time || temp.Time) resultArray.push(temp);}
    }
    return resultArray;
  };

  const formattedGoodOutputHourly = plant?.isHilton
    ? getGoodoutputHourlyDataForFiveMinutes(
        formattedOEE,
        activeStatus,
        updated_at,
        true
      )
    : getGoodoutputHourlyData(formattedOEE, activeStatus, updated_at, true);

    const [isFullScreen, setIsFullScreen] = useState(false);

    const toggleFullScreen = () => {
      setIsFullScreen(!isFullScreen);
    };
  

    return(
        <div className="downtime-div1 p20">
        <div className="dflex justifySB alignCenter">
          <h1 className="pageHead">Line Level Board</h1>
        </div>
        {shiftWiseTarget && (
        <div className={isFullScreen ? 'full-screen' : ''}>
          {/* <div className="dflex justifyFE">
        <ButtonComp onClick={toggleFullScreen} theme={isFullScreen ? "red" : "blue"}
         text= {isFullScreen ? "Exit" : "Full Screen"}
        />
        </div> */}
        <div className="pt10" />
        <Row>
        <Col md={5}>
          <LineLevelBoardTable />
        </Col>
        <Col md={19}>
        <LineLevelBoardTableTwo
  data={formattedGoodOutputHourly}
  isFullScreen={isFullScreen}
  toggleFullScreen={toggleFullScreen}
/>

        </Col>
        <Col md={1}>
        </Col>
      </Row>
      </div>
      )} 
      </div>
    )
}

export default LineLevelBoard;